import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2200To2299Service {

  constructor() { }
}
